import running_routes from './images/facet002.png'

const Running = () => {
	return (
		<div className="running_page">
			<img src={running_routes} className="running_routes" alt="" width="100%"/>
			
			<p className="running">
				A (not up to date) collection of most of my running routes since 2014 totalling over <b>5100</b> km 
				across 800+ runs, courtesy <a href="https://github.com/JoeSwinehart/DataVizProject" target="_blank">Joe 
				Swinehart</a>. Somewhere, hidden in this collage, is the LA 2020 Marathon, several half marathons, 
				quite a few trails runs and races, and some memorable group runs.
			</p>
			
			<p className="running">
				The goal distance for 2023 is an ambitious 1610 km (i.e. 1000 mi):  
				<span className='running_goal'> 167/1610</span>  [01/07/2023]
			</p>

			<p className="running">
				The goal distance for 2022 was the ever elusive 1000 km:  
				<span className='running_goal'> 1000.5/1000</span>  [31/12/2022]
			</p>

			<p className='running'>
				Checkout my <a href="https://oneebkhan.substack.com" target="_blank">running substack</a>, which I hope 
				to resume writing to this year, to follow along for some lofty goals I've set for myself, or maybe 
				follow me on <a href="https://www.strava.com/athletes/51736159" target='_blank'>Strava</a>.
			</p>
		</div>
	);
}

export default Running;